import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProfilePage from "../pages/profile/page";
import StoriesPage from "../pages/stories/page";
import AuthPage from "../pages/auth/page";
import MembershipPage from "../pages/membership/page";
import WarehousePage from "../pages/warehouse/page";
import EducationPage from "../pages/education/page";
import ResellerDashboard from "../pages/reseller/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/warehouse",
    element: <WarehousePage />,
  },
  {
    path: "/education",
    element: <EducationPage />,
  },
  {
    path: "/profile/:id",
    element: <ProfilePage />,
  },
  {
    path: "/stories",
    element: <StoriesPage />,
  },
  {
    path: "/reseller",
    element: <ResellerDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
